<div class="page">

  <div class="page-header">
    <div class="header-left">
      <button class="btn-back" (click)="goBack()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
        Back
      </button>
      <div>
        <h1>Generate AI Ad</h1>
        <p>Create a free AI-generated ad as admin — no payment required</p>
      </div>
    </div>
  </div>

  <div class="error-msg" *ngIf="errorMessage">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/>
      <line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
    {{ errorMessage }}
  </div>

  <form class="form-card" (ngSubmit)="onSubmit()">

    <!-- Source Images -->
    <div class="form-section">
      <h2 class="section-title">Source Images</h2>
      <p class="section-desc">Upload property photos from your device or paste image URLs. Max 5 images.</p>

      <app-media-uploader
        folder="ai-ads"
        [multiple]="true"
        accept="image/*"
        (uploaded)="onImagesUploaded($event)">
      </app-media-uploader>

      <div class="url-fallback">
        <span class="or-label">or paste URL</span>
        <div class="media-input-row">
          <input
            type="text"
            [(ngModel)]="imageInput"
            name="imageInput"
            placeholder="https://example.com/photo.jpg"
            (keydown)="onImageKeydown($event)"
            class="media-input"
          />
          <button type="button" class="btn-add" (click)="addImageUrl()">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
            Add
          </button>
        </div>
      </div>

      <div class="media-list" *ngIf="sourceImages.length > 0">
        <div class="media-item" *ngFor="let url of sourceImages; let i = index">
          <div class="media-thumb">
            <img [src]="url" class="thumb" [alt]="'source-' + i" />
          </div>
          <span class="media-url" [title]="url">{{ url }}</span>
          <button type="button" class="btn-remove" (click)="removeImage(i)">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
      </div>
      <p class="empty-hint" *ngIf="sourceImages.length === 0">No images added yet.</p>
    </div>

    <div class="form-divider"></div>

    <!-- Ad Language -->
    <div class="form-section">
      <h2 class="section-title">Ad Language</h2>
      <p class="section-desc">Choose the language for all generated text in the ad.</p>
      <div class="lang-toggle">
        <button
          type="button"
          class="lang-btn"
          [class.active]="language === 'ar'"
          (click)="language = 'ar'">
          العربية
        </button>
        <button
          type="button"
          class="lang-btn"
          [class.active]="language === 'en'"
          (click)="language = 'en'">
          English
        </button>
      </div>
    </div>

    <div class="form-divider"></div>

    <!-- Caption -->
    <div class="form-section">
      <h2 class="section-title">Caption / Instructions</h2>
      <p class="section-desc">Describe what the AI should generate — property details, style, text to include, etc.</p>

      <div class="form-group">
        <label>Caption <span class="required">*</span></label>
        <textarea
          [(ngModel)]="caption"
          name="caption"
          rows="6"
          placeholder="e.g. Modern apartment in New Cairo, 150 sqm, floor 5, Nile view, price 3.5M EGP, 10-year installment…"
        ></textarea>
      </div>
    </div>

    <div class="form-divider"></div>

    <div class="form-actions">
      <button type="button" class="btn-secondary" (click)="goBack()">Cancel</button>
      <button type="submit" class="btn-primary" [disabled]="isSubmitting">
        <span *ngIf="!isSubmitting">Generate</span>
        <span *ngIf="isSubmitting" class="spinner-sm"></span>
      </button>
    </div>

  </form>
</div>
